import { createApp } from 'vue'
import App from './App.vue'
import router from './router' // 引入路由实例
import i18n from './locales/index'; 

const app = createApp(App);
app
  .use(i18n)    // 先注册国际化
  .use(router)  // 再注册路由（顺序不影响，按需求调整）
  .mount('#app'); // 只执行1次挂载
